import axios from "axios";
import { API_URL } from "../../constants";

export const GetBootPlans = async (ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    const token = sessionStorage.getItem('LOGIN_TOKEN');

    try {
        let res = await axios.get(API_URL + "subscription/boot_plans", {
            headers: {
                'Authorization': "Bearer " + token,
            }
        });
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }

}